import {newUpdateBasketPrice} from "./newUpdateBasketPrice";
import {newUpdatePaymentOwed} from "./newUpdatePaymentOwed";
import {newUpdateBasketTotal} from "./newUpdateBasketTotal";
import {showAlternateOption} from "./showAlternateOption";
import {hideAlternateOption} from "./hideAlternateOption";
import {loadCheckoutPrices} from "./loadCheckoutPrices";

function newUpdateMetalMonetaryUsage(input, overlay = true) {
    var value = 0,
        metal = input.attr('data-metal'),
        currency = $('.checkout-total .checkout-price').attr('data-currency'),
        currency_rate = $('.checkout-total .checkout-price').attr('data-currency_rate');

    if (typeof input.val() != 'undefined' &&
        input.val() != '') {
        value = parseFloat(input.val());
    }

    if (currency != 'gbp' && typeof currency_rate != 'undefined') {
        value = value * parseFloat(currency_rate);
    }

    var data = {
        'metal': metal,
        'value': value
    };

    if (overlay) {
        $('.overlay').fadeIn();
    }

    $.ajax({
        url: '/new-checkout/update-metal-monetary-usage',
        type: 'post',
        data: data,
        dataType: 'json',
        success: function (result) {
            if (result.metal_usage == '0') {
                $('.checkout-basket-metal-usage').hide();
            } else {
                $('.checkout-basket-metal-usage').show();
            }

            newUpdateBasketPrice('.checkout-basket-metal-usage', -Math.abs(result.metal_usage));
            newUpdatePaymentOwed(result);
            newUpdateBasketTotal(result.total);
            loadCheckoutPrices();

            if (value == 0) {
                showAlternateOption(metal);
            } else {
                hideAlternateOption(metal);
            }

            if (overlay) {
                setTimeout(function () {
                    $('.overlay').fadeOut();
                }, 800);
            }
        }
    });
}

export {newUpdateMetalMonetaryUsage}